import { useTranslation } from "react-i18next";
import { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";
import Flag from "react-world-flags";

const languages = [
  { code: "sk", label: "SK", countryCode: "SVK" },
  { code: "en", label: "EN", countryCode: "GBR" },
];

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const currentLanguage =
    languages.find((lang) => lang.code === i18n.language) || languages[0];

  const changeLanguage = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors"
        aria-label="Change language"
      >
        <Flag
          code={currentLanguage.countryCode}
          className="w-6 h-4 object-cover rounded"
        />
        <ChevronDown
          className={`size-4 transition-transform ${isOpen ? "rotate-180" : ""}`}
          aria-hidden="true"
        />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 flex flex-col items-center w-20 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-50">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => changeLanguage(lang.code)}
              className={`w-full mx-auto flex justify-center items-center gap-3 py-2 hover:bg-gray-100 transition-colors ${
                i18n.language === lang.code ? "bg-brand-primary/10" : ""
              }`}
            >
              <Flag
                code={lang.countryCode}
                className="w-6 h-4 object-cover rounded"
              />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
